import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject, Observable, fromEvent, merge } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class NetworkStatusService {
	private onlineSubject: BehaviorSubject<boolean>;
	public online$: Observable<boolean>;
	private intervalId: any;

	constructor(@Inject(PLATFORM_ID) private platformId: any) {
		this.onlineSubject = new BehaviorSubject<boolean>(true);
		this.online$ = this.onlineSubject.asObservable();

		if (isPlatformBrowser(this.platformId)) {
			this.onlineSubject.next(navigator.onLine);

			const online$ = fromEvent(window, 'online').pipe(map(() => true));
			const offline$ = fromEvent(window, 'offline').pipe(map(() => false));

			merge(online$, offline$).subscribe(status => {
				this.onlineSubject.next(status);
			});
		}
	}

	private startNetworkCheck() {
		this.intervalId = setInterval(() => {
			this.checkNetworkStatus().subscribe(isOnline => {
				if (isOnline !== this.onlineSubject.value) {
					this.onlineSubject.next(isOnline);
				}
			});
		}, 60000); // Check every 1 minute (60000 ms)
	}

	private checkNetworkStatus(): Observable<boolean> {
		const urlToCheck = `https://api-adresse.data.gouv.fr/search/?q=verification+connexion+internet`;
		return new Observable(observer => {
			fetch(urlToCheck, { method: 'HEAD' })
				.then(() => observer.next(true))
				.catch(() => observer.next(false))
				.finally(() => observer.complete());
		});
	}

	ngOnDestroy() {
		if (this.intervalId) {
			clearInterval(this.intervalId);
		}
	}

	isOnline(): boolean {
		return this.onlineSubject.value;
	}
}
